import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-square3",
  "use": "icon-square3-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-square3\"><defs><style></style></defs><path d=\"M64 64h896v896H64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol